import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { Socket, ChatSocket } from 'services/api/Socket';
import { ThemeProvider, createThemeMap } from 'services/theme';
import queryString from 'query-string';

import { eventActions as authActions } from './features/Auth/redux';
import { eventActions as historyActions } from './features/History';
import { eventActions as jackpotActions } from './features/Jackpot';
import { eventActions as gameActions } from './features/Game/redux';
import { eventActions as chatActions } from './features/Chat';
import { gameError as socketGameErrorActions } from './features/SocketErrorBoundary/redux';
import { chatError as socketChatErrorActions } from './features/SocketErrorBoundary/redux';
import configureStore from './configureStore';
import Api from './services/api';


import themes from './styles/theme.scss';

const api = new Api(process.env.NODE_ENV === 'production' ? '' : '');

const token = queryString.parse(window.location.search).token;
const lang = queryString.parse(window.location.search).lang;
const homeUrl = queryString.parse(window.location.search).homeUrl;
const socket = new Socket(process.env.NODE_ENV === 'production' ? `wss://${window.location.host}/api/plinko` : 'wss://sandbox.fgstatic.xyz/api/plinko', token, {
  ...authActions,
  ...historyActions,
  ...jackpotActions,
  ...gameActions,
  ...socketGameErrorActions,
})
const chatSocket = new ChatSocket(process.env.NODE_ENV === 'production' ? `wss://${window.location.host}/api/plinko/chat` : 'wss://sandbox.fgstatic.xyz/api/plinko/chat', token, {
  ...chatActions,
  ...socketChatErrorActions,
}, true)

const themeMap = createThemeMap({ themes })
const store = configureStore({ api, socket, chatSocket, themeMap });

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider themeMap={themeMap}>
      <BrowserRouter>
        <App lang={lang} homeUrl={homeUrl} />
      </BrowserRouter>
    </ThemeProvider>
  </Provider>, document.getElementById('root'));
